<template>
  <NuxtLayout
    name="radar"
    :bread-crumb-list="breadcrumb"
  >
    <template #main>
      <div
        v-if="status === 'success'"
        class="main"
      >
        <SectionTitle
          :title="`${data[pointId].point_ja}の雨雲レーダー`"
          :left-text="`現地時刻 ${now.locale(ja).format('M/D(ddd) H時')}`"
          share-category="RADAR_POINT"
          :share-title="title"
          is-h1
        />
        <MapRadar
          :now="now"
          :lat="data[pointId].lat"
          :lon="data[pointId].lon"
          :is-loc="true"
        />
      </div>
    </template>
    <template #main-bottom>
      <div class="main">
        <text-link
          :text="`${data[pointId].point_ja}の天気予報を見る`"
          :href="`${pointId}`"
        />
        <CommonCountryList is-radar />
      </div>
    </template>
  </NuxtLayout>
</template>

<script setup>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import ja from 'dayjs/locale/ja'
import countryIdList from '~/data/table/country_id_list.json'

dayjs.extend(utc)
dayjs.extend(timezone)

const route = useRoute()
const areaId = route.params.area
const country = route.params.country
const pointId = `/${areaId}/${route.params.country}/${route.params.city}/`
const { data, status } = await useFetch(`/api/point/info?pointId=${pointId}`)
if (!data.value[pointId]) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid pointId'
  })
}

const now = dayjs().startOf('hour').tz(data.value[pointId].timezone)

const runtimeConfig = useRuntimeConfig()
const domain = runtimeConfig.public.hostDomain

const breadcrumb = [
  {
    text: '世界天気',
    link: `${domain}/onebox/tenki/world/`
  },
  {
    text: '雨雲レーダー 世界',
    link: `${domain}/onebox/tenki/world/radar/`
  },
  {
    text: `${areaLabelMap[areaId]}`,
    link: `${domain}/onebox/tenki/world/radar/${areaId}/`
  },
  {
    text: countryIdList[`/${areaId}/${country}/`].country_ja,
    link: `${runtimeConfig.public.hostDomain}/onebox/tenki/world/radar/${areaId}/${country}/`
  },
  {
    text: `${data.value[pointId].point_ja}`
  }
]
const title = `${data.value[pointId].point_ja}の雨雲レーダー【${data.value[pointId].country_ja}】- ウェザーニュース`
useCommonHead({
  title,
  description: `【48時間予想の${data.value[pointId].point_ja}雨雲レーダー】リアルタイムな雨雲の動きから最大48時間先の予報まで確認できます。旅の出発前に${data.value[pointId].point_ja}の2週間天気も併せてチェック。天気・気象に関する全てのサポートは【予報精度No.1ウェザーニュース】にお任せください。`,
  keywords: data.value[pointId]?.meta_kw_radar ?? `${data.value[pointId].point_ja},雨雲レーダー,48時間`,
  appTitle: data.value[pointId].point_ja,
  appCountKey: route.path.toLowerCase(),
  iconUrl: `${runtimeConfig.public.gvsUrl}/onebox/img/world/icon/icon_wradar_white@2x.png`,
  iconGrayUrl: `${runtimeConfig.public.gvsUrl}/onebox/img/world/icon/icon_wradar_trans@2x.png`,
  iconSettingUrl: `${runtimeConfig.public.gvsUrl}/onebox/img/world/icon/icon_wradar@2x.png`
})
useCommonJsonld({ breadcrumb })
</script>

<style scoped>
.main {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}
</style>
